import { useEffect } from 'react';
import { useCommandSearchContext } from '../context/CommandSearchContext';

export const useCommandSearch = () => {
  const { isSearchOpen, openSearch, closeSearch } = useCommandSearchContext();

  useEffect(() => {
    const handleKeyDown = (event: KeyboardEvent) => {
      // Cmd+K or Ctrl+K to open search
      if ((event.metaKey || event.ctrlKey) && event.key === 'k') {
        event.preventDefault();
        openSearch();
      }
    };

    document.addEventListener('keydown', handleKeyDown);
    return () => document.removeEventListener('keydown', handleKeyDown);
  }, [openSearch]);

  return {
    isSearchOpen,
    openSearch,
    closeSearch
  };
};